import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import { useAuth } from "../../context/AuthContext";
import GoogleAuthButton from "../../components/Common/GoogleAuthButton";

const Register = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.state?.redirect || "/";

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
    role: "attendee",
  });
  const [status, setStatus] = useState({ state: "idle", message: "" });
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: "sending", message: "" });
    setErrors({});
    try {
      const { redirect_to } = await register(form);
      if (redirect_to) {
        // Organizer registration → pending-approval Blade পেজে পাঠানো হয়।
        window.location.href = redirect_to;
        return;
      }
      navigate(redirect, { replace: true });
    } catch (err) {
      setErrors(err?.response?.data?.errors || {});
      setStatus({
        state: "error",
        message: err?.response?.data?.message || "Register করা যায়নি, আবার চেষ্টা করুন।",
      });
    }
  };

  return (
    <React.Fragment>
      <Header parentMenu="register" activeMenu="/register" />
      <SiteBreadcrumb pageTitle="Sign up" pageName="Sign up" breadcrumbsImg={bannerbg} />

      <section className="contact-one">
        <div className="container">
          <div className="contact-one__inner" style={{ maxWidth: 480, margin: "0 auto" }}>
            <h3 className="contact-one__title">কয়েক সেকেন্ডে অ্যাকাউন্ট তৈরি করুন</h3>

            {status.state === "error" && (
              <p style={{ color: "#e6394f", marginBottom: 16 }}>{status.message}</p>
            )}

            <form onSubmit={handleSubmit} noValidate>
              <div className="contact-one__input-box">
                <input
                  type="text"
                  placeholder="আপনার নাম"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  required
                />
                {errors.name && <small style={{ color: "#e6394f" }}>{errors.name[0]}</small>}
              </div>

              <div className="contact-one__input-box">
                <input
                  type="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                />
                {errors.email && <small style={{ color: "#e6394f" }}>{errors.email[0]}</small>}
              </div>

              <div className="contact-one__input-box">
                <div className="select-box">
                  <select
                    className="selectmenu wide"
                    value={form.role}
                    onChange={(e) => setForm({ ...form, role: e.target.value })}
                  >
                    <option value="attendee">Attendee (ইভেন্টে যোগ দিতে চাই)</option>
                    <option value="organizer">Organizer (ইভেন্ট আয়োজন করতে চাই)</option>
                  </select>
                </div>
              </div>

              <div className="contact-one__input-box">
                <input
                  type="password"
                  placeholder="Password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required
                />
                {errors.password && <small style={{ color: "#e6394f" }}>{errors.password[0]}</small>}
              </div>

              <div className="contact-one__input-box">
                <input
                  type="password"
                  placeholder="Confirm Password"
                  value={form.password_confirmation}
                  onChange={(e) => setForm({ ...form, password_confirmation: e.target.value })}
                  required
                />
              </div>

              <div className="contact-one__btn-box">
                <button
                  type="submit"
                  className="thm-btn contact-one__btn"
                  disabled={status.state === "sending"}
                >
                  {status.state === "sending" ? "তৈরি হচ্ছে..." : "Register"}
                  <span className="icon-arrow-right"></span>
                </button>
              </div>
            </form>

            <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "22px 0" }}>
              <span style={{ flex: 1, height: 1, background: "#e5e5e5" }} />
              <span style={{ color: "#8a8a8a", fontSize: 13 }}>অথবা</span>
              <span style={{ flex: 1, height: 1, background: "#e5e5e5" }} />
            </div>

            <GoogleAuthButton redirect={redirect} label="Google দিয়ে Sign up করুন" />
            <p style={{ fontSize: 12, color: "#8a8a8a", marginTop: 8 }}>
              Google দিয়ে সাইন-আপ করলে account সবসময় Attendee হিসেবে তৈরি হবে।
            </p>

            <p style={{ marginTop: 20 }}>
              আগে থেকেই account আছে? <Link to="/login" state={{ redirect }}>Log in</Link>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default Register;
